"use client";
export const OutputResult = function () {
  return (
    <div className="absolute right-12 top-2 z-10 w-[24rem] rounded bg-white bg-opacity-90 p-2 shadow-md">
      <div className="flex items-center justify-between border-b px-4 py-2">
        {/* Title */}
        <h2 className="text-sm font-semibold text-gray-700">Output Results</h2>
      </div>
      <div className="p-1">
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
          {[
            {value: 4, label: "Vehicles Used"},
            {value: 10, label: "Routes Created"},
            {value: 23, label: "Bus Stops"},
            {value: 54, label: "Students Mapped"}
          ].map((item, idx) => (
            <div
              key={idx}
              className="rounded-md border bg-white p-4 text-center shadow"
            >
              <div className="text-sm font-bold text-green-600">
                {item.value}
              </div>
              <div className="mt-1 text-xs text-gray-600">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="p-1">
        <div className="space-y-4">
          {[
            {
              id: 1,
              color: "bg-blue-600",
              title: "Route test one - TN42AY4295",
              meta: "6 Stops • 22.1 Km • 48 min duration"
            },
            {
              id: 2,
              color: "bg-yellow-500",
              title: "Route testt2  - TN42AY4295",
              meta: "6 Stops • 22.1 Km • 48 min duration"
            }
          ].map(route => (
            <div key={route.id} className="border-b pb-4">
              <label className="flex cursor-pointer items-start space-x-2">
                <input type="checkbox" className="mt-1" />
                <div className="flex flex-col">
                  <div className="flex items-center space-x-2">
                    <span className={`h-3 w-3 rounded-full ${route.color}`} />
                    <span className="text-sm font-semibold">{route.title}</span>
                  </div>
                  <span className="mt-1 text-sm text-gray-500">
                    {route.meta}
                  </span>
                </div>
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
